import { gql } from 'graphql-tag';
export const engagementBySchools = gql `
    query engagementBySchools($districtIds: [String!]!) {
        engagementBySchools(districtIds: $districtIds) {
            maxDaysActivePerActiveStudent
            maxDaysActivePerActiveTeacher
            maxActivityAssignedPerEnrolledStudent
            maxAssessmentAssignedPerEnrolledStudent
            maxAssessmentCompletedPerEnrolledStudent
            engagementBySchools {
                schoolName
                totalActiveStudents
                totalEnrolledStudents
                daysActivePerActiveStudent
                totalActiveTeachers
                totalEnrolledTeachers
                daysActivePerActiveTeacher
                activityAssignedPerEnrolledStudent
                assessmentAssignedPerEnrolledStudent
                assessmentCompletedPerEnrolledStudent
            }
        }
    }
`;
